import { render, staticRenderFns } from "./form-update-card.vue?vue&type=template&id=9d08eb6c&"
import script from "./form-update-card.vue?vue&type=script&lang=js&"
export * from "./form-update-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports